import { useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";

export const Lightbox = ({ items, index, onClose, onNavigate }) => {
    const closeRef = useRef(null);
    const item = items[index];
    const count = items.length;
    const prev = () => onNavigate((index - 1 + count) % count);
    const next = () => onNavigate((index + 1) % count);

    useEffect(() => {
        closeRef.current?.focus();
        const onKey = (e) => {
            if (e.key === "Escape") onClose();
            if (e.key === "ArrowLeft") prev();
            if (e.key === "ArrowRight") next();
        };
        document.addEventListener("keydown", onKey);
        document.body.style.overflow = "hidden";
        return () => {
            document.removeEventListener("keydown", onKey);
            document.body.style.overflow = "";
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [index]);

    if (!item) return null;
    return (
        <div
            className="fixed inset-0 z-[60] bg-carbone/95 backdrop-blur-sm flex items-center justify-center p-4"
            role="dialog"
            aria-modal="true"
            aria-label={item.alt || "Foto"}
            data-testid="gallery-lightbox"
            onClick={onClose}
        >
            <div className="max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
                <div className="flex justify-between items-center mb-3">
                    <span className="text-sm text-avorio/70 tabular">
                        {index + 1} / {count}
                    </span>
                    <button
                        ref={closeRef}
                        onClick={onClose}
                        aria-label="Chiudi la foto"
                        className="btn btn-outline !p-3"
                        data-testid="lightbox-close-btn"
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>
                <img
                    src={item.src}
                    alt={item.alt || ""}
                    className="w-full max-h-[75vh] object-contain rounded-xl"
                    data-testid="lightbox-image"
                />
                <div className="flex justify-between mt-3">
                    <button onClick={prev} aria-label="Foto precedente" className="btn btn-outline !p-3" data-testid="lightbox-prev-btn">
                        <ChevronLeft className="w-5 h-5" />
                    </button>
                    <button onClick={next} aria-label="Foto successiva" className="btn btn-outline !p-3" data-testid="lightbox-next-btn">
                        <ChevronRight className="w-5 h-5" />
                    </button>
                </div>
            </div>
        </div>
    );
};